import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import { environment } from "../../../environments/environment";
import { EMAIL_PATTERN } from "../../@auth/components/constants";
import { Project } from "../../models/project.model";

import { ProjectService } from "../../services/project.service";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

@Component({
  selector: "ngx-dialog-project",
  templateUrl: "dialog-project.component.html",
  styleUrls: ["dialog-project.component.scss"],
})
export class DialogProjectComponent implements OnInit {
  @Input() header: string;
  @Input() mode: string;
  @Input() shopId: string;
  @Input() project: Project = new Project();

  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imageURL = "";
  imagesUrl = [];
  menu = "info";
  subMenu = "why"; //why/how/what/purpose/rules
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(
    protected ref: NbDialogRef<DialogProjectComponent>,
    private fb: FormBuilder,
    private projectService: ProjectService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    this.diaForm = this.fb.group({
      title: ["", fullNameValidators],
      description: [""],
    });

    if (this.project.tags && this.project.tags.length > 0) {
      var trees = new Set([]);
      this.project.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("KH");
    }
    if (!this.project.sourceType || this.project.sourceType == "") {
      this.project.sourceType = "document";
    }
    if (this.project.coverUrl && this.project.coverUrl != "") {
      this.imageURL = this.project.coverUrl;
    }
    if (this.project.imagesUrl && this.project.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.project.imagesUrl);
    }
    if (!this.project.content) {
      this.project.content = "";
    }
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.project);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  selectSubMenu(value) {
    this.subMenu = value;
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.project.tags = tags;

    this.project.coverUrl = this.project.coverUrl ? this.project.coverUrl : "";

    this.project.description = this.project.description
      ? this.project.description
      : "";
    this.project.tags = this.project.tags ? this.project.tags : [];
    this.project.imagesUrl = this.project.imagesUrl
      ? this.project.imagesUrl
      : [];

    this.project.budget = this.project.budget
      ? parseFloat(this.project.budget.toString())
      : 0;

    if (this.mode == "edit") {
      this.edit();
    } else {
      this.create();
    }
  }

  create() {
    this.loading = true;
    this.submitted = true;

    console.log("create:", this.project);

    this.projectService
      .create(this.project)
      .then((data) => {
        this.project = data;

        this.loading = false;
        this.submitted = false;

        this.ref.close(this.project);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  edit() {
    this.loading = true;
    this.submitted = true;

    this.projectService
      .update(this.project)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.edited = true;
        this.ref.close(this.project);
        this.showToast("success", "Cập nhật nhà cung cấp", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật nhà cung cấp", "thất bại");
      });
  }

  delete(item: Project) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nhân viên này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.projectService
            .delete(item.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.ref.close(this.project);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.project.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.project.coverUrl = "";
    this.imageURL = "/assets/images/image-upload-bg.jpg";
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.project.imagesUrl) {
      this.project.imagesUrl = [];
    }
    this.project.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.project.imagesUrl, (el) => {
      return el == item;
    });
    remove(this.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value);
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
